// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BridgeComponent from "./native-back-button_controller"
import isLoggedInController from "./native-is_logged_in_controller"
application.register("native-back-button", BridgeComponent)
application.register("native-is-logged-in", isLoggedInController)
